import { Component, Inject, Optional, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.scss'],
  standalone: false
})
export class ProductImagesComponent implements OnInit, OnChanges {
  hideCarousel = false;
  index = 0;
  imgSources = [];
  isDialog = false;
  @Output() imageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Input() items: [];

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data) {
    if (data) {
      this.imgSources = data.items;
      this.hideCarousel = data.hideCarousel;
      this.index = data.index || 0;
      this.isDialog = true;
    }
  }

  ngOnInit(): void {
    if (this.items?.length) {
      this.imgSources = this.items;
    }
  }

  ngOnChanges(): void {
    this.imgSources = this.items;
  }

  /**
   * Emits the event on imageChanged
   * @param event - The change image event index
   */
  imageChange(event: number) {
    this.imageChanged.emit(event);
  }

}
